// Поскольку мы используем JSX (синтаксис, похожий на HTML),
// нам нужно импортировать React.
import React from 'react';

// ===================================================================
// ИМПОРТ КОМПОНЕНТОВ-СЕКЦИЙ
// ===================================================================
// Каждая секция нашего одностраничного сайта будет отдельным компонентом.
// Это позволяет держать код организованным и легко вносить изменения в 
// конкретный блок, не затрагивая остальные.
//
// Мы пока только объявляем эти импорты. На следующих шагах мы создадим
// каждый из этих файлов.

// Импортируем компонент 'Header' (шапка сайта)
import Header from './components/Header/Header';

// Импортируем главные секции страницы
import HeroSection from './components/sections/HeroSection';
import BenefitsSection from './components/sections/BenefitsSection';
import CatalogSection from './components/sections/CatalogSection';
import SocialProofSection from './components/sections/SocialProofSection';
import LeadMagnetSection from './components/sections/LeadMagnetSection';
import ContactSection from './components/sections/ContactSection';
import SalePitchSection from './components/sections/SalePitchSection';

// Импортируем компонент 'Footer' (подвал сайта)
import Footer from './components/Footer/Footer';


// ===================================================================
// ГЛАВНЫЙ КОМПОНЕНТ ПРИЛОЖЕНИЯ 'App'
// ===================================================================
// Это функциональный компонент React. Он возвращает JSX-разметку,
// которая описывает, как должен выглядеть наш сайт.
function App() {
  return (
    // React-компоненты должны возвращать один родительский элемент.
    // Пустые скобки <>...</> - это сокращенная запись для <React.Fragment>.
    // Фрагмент позволяет сгруппировать несколько элементов, не добавляя
    // лишний <div> в итоговую HTML-структуру.
    <>
      {/* 
        Шапка сайта. Она будет "прилипать" к верху страницы 
        или быть статичной, в зависимости от дизайна.
      */}
      <Header />

      {/* 
        Основное содержимое страницы. Тег <main> важен для семантики
        и доступности - он указывает, где находится главный контент.
      */}
      <main>
        {/* 
          Располагаем все наши секции в том порядке, в котором они
          должны идти на странице.
        */}
        
        {/* 1. Первый экран с главным предложением */}
        <HeroSection />

        {/* 2. Блок с ключевыми преимуществами компании */}
        <BenefitsSection />

        {/* 3. Каталог продукции (БРУ) */}
        <CatalogSection />

        {/* 4. Секция с отзывами или логотипами клиентов (социальное доказательство) */}
        <SocialProofSection />

        {/* 5. Предложение скачать полезный материал (лид-магнит) */}
        <LeadMagnetSection />

        {/* 6. Улучшенная форма для сбора заявок */}
        <ContactSection />
        
        {/* 7. Специальная секция для потенциального покупателя сайта */}
        <SalePitchSection />
      </main>

      {/* 
        Подвал сайта. Здесь будут контакты, копирайт и полезные ссылки.
      */}
      <Footer />
    </>
  );
}

// Экспортируем компонент App, чтобы его можно было импортировать
// в файле src/index.js, что мы уже сделали ранее.
export default App;